import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';

const state = {
    id: 0,
    nombre: '',
    inactivo: false,
    rowVersion: null,

    cargoDatos: [],
};

const mutations = {
    updateField,

    'INICIALIZAR' (state, cargoId) {
        state.id = cargoId;
        state.nombre = '';
        state.inactivo = false;
        state.rowVersion = null;
    },
    'SET_CARGO' (state, cargo) {
        state.nombre = cargo.nombre.trim();
        state.inactivo = cargo.inactivo;
        state.rowVersion = cargo.rowVersion;
    },

    'INICIALIZAR_DATOS' (state) {
        state.cargoDatos = [];
    },
    'SET_DATOS' (state, cargoDatos) {
        state.cargoDatos = cargoDatos;
    },
};

const getters = {
    getField,
};

const actions = {
    inicializarCargo ( { commit }, cargoId ) {
        return new Promise((resolve, reject) => { 
            commit('INICIALIZAR', cargoId);

            if (cargoId != 0)
            {
                apiAxios.get('cargos/' + cargoId + '/abm' ) 
                .then(res => {
                    commit('SET_CARGO', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
        }, error => {
            reject(error);
        })
    },
    save ( { state } ) {
        return new Promise((resolve, reject) => {
            let cargo = {
                nombre: state.nombre.trim().toUpperCase(),
                inactivo: state.inactivo,
            }
            let url = 'cargos';
            if (state.id != 0) {
                url += '/' + state.id;
                cargo.rowVersion= state.rowVersion;
            }

            apiAxios.post(url, cargo)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getCargoDatos ( { commit }, cargoId ) {
        return new Promise((resolve, reject) => { 
            commit('INICIALIZAR_DATOS');

            apiAxios.get('cargos/' + cargoId) 
            .then(res => {
                var datos = [
                    { 'nombre': 'id', 'campo': 'Cod.', 'valor': res.data.id, 'formato': '' },
                    { 'nombre': 'nombre', 'campo': 'Nombre', 'valor': res.data.nombre, 'formato': '' },
                    { 'nombre': 'inactivo', 'campo': 'Inactivo', 'valor': (res.data.inactivo)? 'Si' : 'No', 'formato': '' },
                ];
                commit('SET_DATOS', datos);
                resolve()
            })
            .catch(error => reject(helpers.methods.getErrorMessage(error)));
        }, error => {
            reject(error);
        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}